<template>
    <div class="title_top_level">
        <div class="login-title-container">
            <img src="/img/bg/logo1.png" class="logo1-size" />
            <div class="login-title-header">
                <!-- <div class="title">公益项目信息化管理系统</div>
                <div>Juvenile delinquency prevention system</div> -->
                <img src="/img/bg/logo2.png" class="title" />
            </div>
            <div class="other-logo">
                <!-- <img src="/img/bg/b1.png" class="logo2-size" />
                <img src="/img/bg/b2.png" class="logo2-size" />
                <img src="/img/bg/b3.png" class="logo2-size" /> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
	name:'loginheader'
}

</script>
<style lang="scss">
@import "@/styles/login.scss";

</style>
